export default "__VITE_ASSET__646358a7__"